<template>
  <span v-if="effectiveStatus">
    <span
      class="tag"
      :class="tagClass"
    >
      {{ label }}
    </span>
  </span>
</template>

<script>
export default {
  name: 'oracle-po-status-display',
  props: {
    status: {
      type: String,
      default: null,
    },
    order: {
      type: Object,
      default: null,
    },
  },
  computed: {
    effectiveStatus() {
      if (this.status) {
        return this.status;
      }
      if (!this.order) {
        return null;
      }
      if (this.order.oraclePoStatus) {
        return this.order.oraclePoStatus;
      }
      if (
        this.order.oracleStatus === 'CREATED'
        || this.order.oracleStatus === 'PROCESSING'
      ) {
        return 'SENDING';
      }
      if (!this.order.oracleId) {
        return 'NOT_SENT';
      }
      return null;
    },
    label() {
      if (!this.effectiveStatus) {
        return '';
      }
      const key = `oraclePoStatus.${this.effectiveStatus}`;
      return this.$te(key) ? this.$t(key) : this.effectiveStatus;
    },
    tagClass() {
      switch (this.effectiveStatus) {
        case 'ERROR':
          return 'is-danger';
        case 'SENDING':
          return 'is-warning';
        case 'NON_CONCERNED':
          return 'is-light';
        case 'NOT_SENT':
          return 'is-info';
        case 'OPEN':
        case 'SYNCHRONIZED':
          return 'is-success';
        default:
          return 'is-info';
      }
    },
  },
};
</script>
